import { z } from "zod";

import type { TFunction } from "~/i18n";

export function createLoginSchema(t: TFunction) {
  return z.object({
    email: z
      .string()
      .min(1, t("forms.common.requiredField"))
      .email(t("forms.inputs.email.invalid")),
    password: z.string().min(1, t("forms.common.requiredField")),
  });
}

export type LoginFormValues = z.infer<ReturnType<typeof createLoginSchema>>;
